export default "__VITE_ASSET__7352bbac__"